/** Home page biography section with compact profile links. */
import React from 'react';

import { useSiteMetadata } from '../../../utils/hooks';
import Utils from '../../../utils/pageUtils';
import FlipAvatar from '../../FlipAvatar';

import * as styles from './homePage.module.less';

/**
 * Render the hero: a small photo at the top right with the name and introduction
 * wrapping beside it. The social icons live in the header bar.
 */
const AboutMe = () => {
  const siteMetadata = useSiteMetadata();
  const description = siteMetadata.introduction.join('\n\n');
  const markdown = Utils.parseMarkDown(description);
  const name = siteMetadata.authorAlternative || siteMetadata.author;

  return (
    <div className={`${styles.homepageSection} ${styles.aboutHeroSection}`}>
      <div className={styles.aboutHero}>
        <div className={styles.aboutHeroAside}>
          <FlipAvatar
            className={styles.aboutHeroAvatar}
            imageSrcs={Utils.getAvatarImageUrls(siteMetadata)}
            alt={name}
          />
        </div>
        <h1 className={styles.aboutHeroName}>{name}</h1>
        <div
          className={`markdown-body ${styles.aboutHeroIntro}`}
          dangerouslySetInnerHTML={{ __html: markdown }}
        />
      </div>

      {/*      <Row gutter={[20, 20]}>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="location.png"
            height={60}
            alt="location image"
            textH4="Born and bought up in"
            textH3="Mangalore, KA, India"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="coffee.png"
            alt="coffee image"
            textH4="Love Coffee"
            textH3="Coffee + Me = Happiness"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="meeting.png"
            alt="meeting image"
            textH4="Socially Awkward"
            textH3="At times"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="motorcycle.png"
            alt="motorcycle image"
            textH4="Love Riding"
            textH3="Biker for life"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="web.png"
            alt="web image"
            textH4="Self Taught Programmer"
            textH3="Thanks to the Web Resources"
            height={60}
            width={60}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="graduation.png"
            alt="graduation image"
            textH4="Pursued B.Tech in"
            textH3="Computer Science"
            height={60}
            width={60}
          />
        </Col>
      </Row> */}
    </div>
  );
};
export default AboutMe;
